export const HUB_HOME_SECTION_KEYS = {
  HERO_BANNERS: "hero_banners",
  MODULE_TILES: "module_tiles",
  SELLER_PRODUCTS: "seller_products",
  SPONSORED_BANNERS: "sponsored_banners",
  TRADING_CATEGORIES: "trading_categories",
  FEATURED_CATEGORY_SHOWCASE: "featured_category_showcase",
  QUICK_BUY_REQUEST: "quick_buy_request",
  TOP_INDUSTRIES: "top_industries",
  CONTRACT_MANUFACTURERS: "contract_manufacturers",
  ACTIVE_AUCTIONS: "active_auctions",
  INFRASTRUCTURE_LEASING: "infrastructure_leasing",
  PROMO_BANNERS: "promo_banners",
};

export const HUB_MODULE_TILE_OPTIONS = [
  {
    key: "auctions",
    label: "Auctions",
    description: "Discover and participate in live and upcoming auctions.",
    tone: "auctions",
  },
  {
    key: "cm",
    label: "Contract Manufacturing",
    description: "Connect with verified manufacturers for custom production and OEM needs.",
    tone: "manufacturing",
  },
  {
    key: "infra",
    label: "Infrastructure Leasing",
    description: "Browse industrial infrastructure available for lease or rent.",
    tone: "infra",
  },
  {
    key: "service_providers",
    label: "Service Providers",
    description: "Access legal, QA, consulting and other professional B2B services.",
    tone: "services",
  },
  {
    key: "logistics",
    label: "Logistics",
    description: "Find freight, warehousing, and end-to-end logistics partners.",
    tone: "logistics",
  },
  {
    key: "p2p",
    label: "Procurement-as-a-Service",
    description: "Hire sourcing professionals to run RFQs and procurement for you.",
    tone: "procurement",
  },
];

export const DEFAULT_VISIBLE_MODULE_TILE_KEYS = HUB_MODULE_TILE_OPTIONS.map((tile) => tile.key);

export const DEFAULT_SELLER_PRODUCTS_ROWS = 2;
export const DEFAULT_SELLER_PRODUCTS_PER_ROW = 4;

export const GRID_CONFIGURABLE_SECTION_KEYS = [
  HUB_HOME_SECTION_KEYS.SELLER_PRODUCTS,
  HUB_HOME_SECTION_KEYS.TRADING_CATEGORIES,
  HUB_HOME_SECTION_KEYS.FEATURED_CATEGORY_SHOWCASE,
  HUB_HOME_SECTION_KEYS.TOP_INDUSTRIES,
  HUB_HOME_SECTION_KEYS.CONTRACT_MANUFACTURERS,
  HUB_HOME_SECTION_KEYS.ACTIVE_AUCTIONS,
  HUB_HOME_SECTION_KEYS.INFRASTRUCTURE_LEASING,
];

export const DEFAULT_GRID_CONFIG_BY_SECTION = {
  [HUB_HOME_SECTION_KEYS.SELLER_PRODUCTS]: { rows: 2, products_per_row: 4 },
  [HUB_HOME_SECTION_KEYS.TRADING_CATEGORIES]: { rows: 2, products_per_row: 5 },
  [HUB_HOME_SECTION_KEYS.FEATURED_CATEGORY_SHOWCASE]: { rows: 2, products_per_row: 4 },
  [HUB_HOME_SECTION_KEYS.TOP_INDUSTRIES]: { rows: 2, products_per_row: 5 },
  [HUB_HOME_SECTION_KEYS.CONTRACT_MANUFACTURERS]: { rows: 2, products_per_row: 4 },
  [HUB_HOME_SECTION_KEYS.ACTIVE_AUCTIONS]: { rows: 2, products_per_row: 4 },
  [HUB_HOME_SECTION_KEYS.INFRASTRUCTURE_LEASING]: { rows: 1, products_per_row: 4 },
};

export const GRID_SECTION_DISPLAY_LABELS = {
  [HUB_HOME_SECTION_KEYS.SELLER_PRODUCTS]: {
    title: "Seller Products Display",
    perRowLabel: "Products per row",
    perRowOption: "products",
    totalLabel: "products",
  },
  [HUB_HOME_SECTION_KEYS.TRADING_CATEGORIES]: {
    title: "Trending Categories Display",
    perRowLabel: "Categories per row",
    perRowOption: "categories",
    totalLabel: "categories",
  },
  [HUB_HOME_SECTION_KEYS.FEATURED_CATEGORY_SHOWCASE]: {
    title: "Featured Category Display",
    perRowLabel: "Sub-categories per row",
    perRowOption: "sub-categories",
    totalLabel: "sub-categories",
  },
  [HUB_HOME_SECTION_KEYS.TOP_INDUSTRIES]: {
    title: "Top Industries Display",
    perRowLabel: "Industries per row",
    perRowOption: "industries",
    totalLabel: "industries",
  },
  [HUB_HOME_SECTION_KEYS.CONTRACT_MANUFACTURERS]: {
    title: "Contract Manufacturers Display",
    perRowLabel: "Manufacturers per row",
    perRowOption: "manufacturers",
    totalLabel: "manufacturers",
  },
  [HUB_HOME_SECTION_KEYS.ACTIVE_AUCTIONS]: {
    title: "Active Auctions Display",
    perRowLabel: "Auctions per row",
    perRowOption: "auctions",
    totalLabel: "auctions",
  },
  [HUB_HOME_SECTION_KEYS.INFRASTRUCTURE_LEASING]: {
    title: "Infrastructure Leasing Display",
    perRowLabel: "Listings per row",
    perRowOption: "listings",
    totalLabel: "listings",
  },
};

export const SELLER_PRODUCTS_ROW_OPTIONS = [1, 2, 3, 4, 5, 6];
export const SELLER_PRODUCTS_PER_ROW_OPTIONS = [2, 3, 4, 5, 6];

export const HUB_HOME_SECTION_VISUALS = {
  [HUB_HOME_SECTION_KEYS.HERO_BANNERS]: { tone: "purple", typeLabel: "Banner - HOME", filter: "banner" },
  [HUB_HOME_SECTION_KEYS.MODULE_TILES]: { tone: "orange", typeLabel: "Quick Links", filter: "content" },
  [HUB_HOME_SECTION_KEYS.SELLER_PRODUCTS]: { tone: "green", typeLabel: "Product Grid", filter: "content" },
  [HUB_HOME_SECTION_KEYS.SPONSORED_BANNERS]: { tone: "blue", typeLabel: "Banner - SPONSORED", filter: "banner" },
  [HUB_HOME_SECTION_KEYS.TRADING_CATEGORIES]: { tone: "indigo", typeLabel: "Category Grid", filter: "content" },
  [HUB_HOME_SECTION_KEYS.FEATURED_CATEGORY_SHOWCASE]: { tone: "rose", typeLabel: "Category Showcase", filter: "content" },
  [HUB_HOME_SECTION_KEYS.QUICK_BUY_REQUEST]: { tone: "orange", typeLabel: "Buyer Form", filter: "content" },
  [HUB_HOME_SECTION_KEYS.TOP_INDUSTRIES]: { tone: "cyan", typeLabel: "Industry Grid", filter: "content" },
  [HUB_HOME_SECTION_KEYS.CONTRACT_MANUFACTURERS]: { tone: "amber", typeLabel: "Manufacturer Grid", filter: "content" },
  [HUB_HOME_SECTION_KEYS.ACTIVE_AUCTIONS]: { tone: "red", typeLabel: "Auction Grid", filter: "content" },
  [HUB_HOME_SECTION_KEYS.INFRASTRUCTURE_LEASING]: { tone: "teal", typeLabel: "Listing Grid", filter: "content" },
  [HUB_HOME_SECTION_KEYS.PROMO_BANNERS]: { tone: "pink", typeLabel: "Banner - PROMO", filter: "banner" },
};

export const DEFAULT_HUB_HOME_SECTIONS = [
  {
    section_key: HUB_HOME_SECTION_KEYS.HERO_BANNERS,
    display_name: "Hero Banner (Top Carousel)",
    description: "Main home slider at the top of the page.",
    banner_type: "HOME",
    is_visible: true,
    display_order: 10,
  },
  {
    section_key: HUB_HOME_SECTION_KEYS.MODULE_TILES,
    display_name: "Service Quick Links",
    description: "Auctions, CM, Infrastructure, Service Providers, Logistics, and Procurement tiles.",
    banner_type: null,
    is_visible: true,
    display_order: 20,
  },
  {
    section_key: HUB_HOME_SECTION_KEYS.SELLER_PRODUCTS,
    display_name: "Seller Products",
    description: "Featured seller product cards.",
    banner_type: null,
    is_visible: true,
    display_order: 30,
  },
  {
    section_key: HUB_HOME_SECTION_KEYS.SPONSORED_BANNERS,
    display_name: "Mid Page Ad Banner",
    description: "Sponsored carousel between content sections.",
    banner_type: "SPONSORED",
    is_visible: true,
    display_order: 40,
  },
  {
    section_key: HUB_HOME_SECTION_KEYS.TRADING_CATEGORIES,
    display_name: "Trending Categories",
    description: "Top marketplace categories with popular sub-categories.",
    banner_type: null,
    is_visible: true,
    display_order: 45,
  },
  {
    section_key: HUB_HOME_SECTION_KEYS.FEATURED_CATEGORY_SHOWCASE,
    display_name: "Featured Category Showcase",
    description: "Highlight one category with sub-category image grid.",
    banner_type: null,
    is_visible: true,
    display_order: 47,
  },
  {
    section_key: HUB_HOME_SECTION_KEYS.QUICK_BUY_REQUEST,
    display_name: "Quick Buy Request",
    description: "Quick RFQ form for buyers above Contract Manufacturers.",
    banner_type: null,
    is_visible: true,
    display_order: 48,
  },
  {
    section_key: HUB_HOME_SECTION_KEYS.TOP_INDUSTRIES,
    display_name: "Top Industries",
    description: "Top contract manufacturing industries by manufacturer count.",
    banner_type: null,
    is_visible: true,
    display_order: 49,
  },
  {
    section_key: HUB_HOME_SECTION_KEYS.CONTRACT_MANUFACTURERS,
    display_name: "Contract Manufacturers",
    description: "Contract manufacturer cards with industry filters.",
    banner_type: null,
    is_visible: true,
    display_order: 50,
  },
  {
    section_key: HUB_HOME_SECTION_KEYS.ACTIVE_AUCTIONS,
    display_name: "Active Auctions",
    description: "Live auction listings with category tabs.",
    banner_type: null,
    is_visible: true,
    display_order: 60,
  },
  {
    section_key: HUB_HOME_SECTION_KEYS.INFRASTRUCTURE_LEASING,
    display_name: "Infrastructure Leasing",
    description: "Infrastructure leasing listing cards.",
    banner_type: null,
    is_visible: true,
    display_order: 70,
  },
  {
    section_key: HUB_HOME_SECTION_KEYS.PROMO_BANNERS,
    display_name: "Bottom Ad Banner",
    description: "Promotional carousel before the footer.",
    banner_type: "PROMO",
    is_visible: true,
    display_order: 80,
  },
];

export function normalizeHubHomeSections(sections) {
  const list = Array.isArray(sections) ? sections : [];
  if (!list.length) return DEFAULT_HUB_HOME_SECTIONS;
  return list
    .map((section) => ({
      section_key: String(section.section_key || section.sectionKey || "").trim(),
      display_name: String(section.display_name || section.displayName || "").trim(),
      description: section.description ?? null,
      banner_type: section.banner_type ?? section.bannerType ?? null,
      section_config: section.section_config ?? section.sectionConfig ?? null,
      is_visible: section.is_visible !== false && section.isVisible !== false,
      display_order: Number(section.display_order ?? section.displayOrder ?? 0),
    }))
    .filter((section) => section.section_key)
    .sort((a, b) => a.display_order - b.display_order || a.section_key.localeCompare(b.section_key));
}

export function isHubHomeSectionVisible(sections, key) {
  const normalized = normalizeHubHomeSections(sections);
  const match = normalized.find((section) => section.section_key === key);
  return match ? match.is_visible !== false : true;
}

export function getVisibleHubHomeSectionOrder(sections) {
  return normalizeHubHomeSections(sections)
    .filter((section) => section.is_visible !== false)
    .map((section) => section.section_key);
}

export function bannerManagementHrefForType(bannerType) {
  const type = String(bannerType || "").toUpperCase();
  if (!type) return "/super-admin/master-data/banner-management";
  return `/super-admin/master-data/banner-management?type=${encodeURIComponent(type)}`;
}

export function resolveVisibleModuleTileKeys(sectionConfig) {
  const configured = sectionConfig?.visible_module_tiles;
  const validKeys = new Set(DEFAULT_VISIBLE_MODULE_TILE_KEYS);

  if (!Array.isArray(configured) || !configured.length) {
    return [...DEFAULT_VISIBLE_MODULE_TILE_KEYS];
  }

  const seen = new Set();
  const resolved = [];
  for (const key of configured) {
    const normalized = String(key || "").trim();
    if (!validKeys.has(normalized) || seen.has(normalized)) continue;
    seen.add(normalized);
    resolved.push(normalized);
  }

  return resolved.length ? resolved : [...DEFAULT_VISIBLE_MODULE_TILE_KEYS];
}

export function getModuleTilesConfig(sections) {
  const match = normalizeHubHomeSections(sections).find(
    (section) => section.section_key === HUB_HOME_SECTION_KEYS.MODULE_TILES,
  );
  return match?.section_config ?? null;
}

export function resolveSectionGridConfig(sectionKey, sectionConfig) {
  const defaults =
    DEFAULT_GRID_CONFIG_BY_SECTION[sectionKey] || DEFAULT_GRID_CONFIG_BY_SECTION[HUB_HOME_SECTION_KEYS.SELLER_PRODUCTS];
  const rows = Number(sectionConfig?.rows);
  const productsPerRow = Number(sectionConfig?.products_per_row);

  const resolvedRows =
    Number.isFinite(rows) && rows >= 1 && rows <= 6 ? Math.trunc(rows) : defaults.rows;

  const resolvedPerRow =
    Number.isFinite(productsPerRow) && productsPerRow >= 2 && productsPerRow <= 6
      ? Math.trunc(productsPerRow)
      : defaults.products_per_row;

  return {
    rows: resolvedRows,
    products_per_row: resolvedPerRow,
    total_items: resolvedRows * resolvedPerRow,
  };
}

export function resolveSellerProductsDisplayConfig(sectionConfig) {
  const config = resolveSectionGridConfig(HUB_HOME_SECTION_KEYS.SELLER_PRODUCTS, sectionConfig);
  return {
    rows: config.rows,
    products_per_row: config.products_per_row,
    total_products: config.total_items,
  };
}

export function getSectionGridConfig(sections, sectionKey) {
  const match = normalizeHubHomeSections(sections).find((section) => section.section_key === sectionKey);
  return resolveSectionGridConfig(sectionKey, match?.section_config);
}

export function getSellerProductsConfig(sections) {
  return getSectionGridConfig(sections, HUB_HOME_SECTION_KEYS.SELLER_PRODUCTS);
}

export const TRADING_CATEGORY_MAX_SUBCATEGORIES = 4;

function normalizeIdList(input, max) {
  if (!Array.isArray(input)) return [];
  const seen = new Set();
  const resolved = [];
  for (const value of input) {
    const id = Number(value);
    if (!Number.isFinite(id) || id <= 0 || seen.has(id)) continue;
    seen.add(id);
    resolved.push(id);
    if (resolved.length >= max) break;
  }
  return resolved;
}

export function resolveTradingCategorySelections(sectionConfig, maxCategories = null) {
  const configured = sectionConfig?.visible_categories;
  if (!Array.isArray(configured) || !configured.length) {
    return [];
  }

  const limit =
    Number.isFinite(Number(maxCategories)) && Number(maxCategories) > 0
      ? Math.trunc(Number(maxCategories))
      : null;

  const seen = new Set();
  const resolved = [];

  for (const item of configured) {
    const categoryId = Number(item?.category_id);
    if (!Number.isFinite(categoryId) || categoryId <= 0 || seen.has(categoryId)) continue;
    seen.add(categoryId);

    const subcategoryIds = normalizeIdList(item?.subcategory_ids, TRADING_CATEGORY_MAX_SUBCATEGORIES);

    resolved.push({
      category_id: categoryId,
      subcategory_ids: subcategoryIds,
    });

    if (limit != null && resolved.length >= limit) break;
  }

  return resolved;
}

export function buildTradingCategoriesSectionConfig(sectionConfig, categorySelections) {
  const grid = resolveSectionGridConfig(HUB_HOME_SECTION_KEYS.TRADING_CATEGORIES, sectionConfig);
  const visible = categorySelections.slice(0, grid.total_items).map((selection) => ({
    category_id: selection.category_id,
    subcategory_ids: normalizeIdList(selection.subcategory_ids, TRADING_CATEGORY_MAX_SUBCATEGORIES),
  }));

  return {
    rows: grid.rows,
    products_per_row: grid.products_per_row,
    visible_categories: visible,
  };
}

export function resolveFeaturedCategoryShowcaseConfig(sectionConfig) {
  const grid = resolveSectionGridConfig(HUB_HOME_SECTION_KEYS.FEATURED_CATEGORY_SHOWCASE, sectionConfig);
  const categoryId = Number(sectionConfig?.category_id);
  return {
    rows: grid.rows,
    products_per_row: grid.products_per_row,
    total_items: grid.total_items,
    category_id: Number.isFinite(categoryId) && categoryId > 0 ? categoryId : null,
    description: String(sectionConfig?.description ?? "").trim(),
    subcategory_ids: normalizeIdList(sectionConfig?.subcategory_ids, grid.total_items),
  };
}

export function buildFeaturedCategoryShowcaseSectionConfig(sectionConfig, payload) {
  const grid = resolveSectionGridConfig(HUB_HOME_SECTION_KEYS.FEATURED_CATEGORY_SHOWCASE, sectionConfig);
  const categoryId = Number(payload?.category_id);
  return {
    rows: grid.rows,
    products_per_row: grid.products_per_row,
    category_id: Number.isFinite(categoryId) && categoryId > 0 ? categoryId : null,
    description: String(payload?.description ?? "").trim().slice(0, 500),
    subcategory_ids: normalizeIdList(payload?.subcategory_ids, grid.total_items),
  };
}

function normalizeIndustrySlug(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function resolveTopIndustrySlugs(sectionConfig, limit) {
  const configured = sectionConfig?.visible_industry_slugs;
  if (!Array.isArray(configured) || !configured.length) return [];

  const seen = new Set();
  const resolved = [];

  for (const item of configured) {
    const slug = normalizeIndustrySlug(item);
    if (!slug || seen.has(slug)) continue;
    seen.add(slug);
    resolved.push(slug);
    if (limit != null && resolved.length >= limit) break;
  }

  return resolved;
}

export function buildTopIndustriesSectionConfig(sectionConfig, industrySlugs) {
  const grid = resolveSectionGridConfig(HUB_HOME_SECTION_KEYS.TOP_INDUSTRIES, sectionConfig);
  const visible = resolveTopIndustrySlugs({ visible_industry_slugs: industrySlugs }, grid.total_items);

  return {
    rows: grid.rows,
    products_per_row: grid.products_per_row,
    visible_industry_slugs: visible,
  };
}

export function isGridConfigurableSection(sectionKey) {
  return GRID_CONFIGURABLE_SECTION_KEYS.includes(sectionKey);
}
